function formatMoney(currencyCode, amount) {
  return new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: currencyCode || 'GBP',
    currencyDisplay: 'narrowSymbol'
  }).format(amount)
}

export function currencySymbol(currencyCode) {
  return new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: currencyCode || 'GBP',
    currencyDisplay: 'narrowSymbol'
  })
    .formatToParts(0)
    .find((part) => part.type === 'currency').value
}

export function formatCurrency(currencyCode, value, fallback = '-') {
  const price = Number(value)

  return price === 0 ? fallback : formatMoney(currencyCode, price)
}

export function formatCurrencyWith0(currencyCode, value) {
  const price = Number(value)

  return formatMoney(currencyCode, price)
}

export function roundToNDecimalPlaces(amount, decimals) {
  return +`${Math.round(`${amount}e+${decimals}`)}e-${decimals}`
}
